module.exports = "<form action=\"\">\n  <!-- <input type=\"text\" placeholder=\"subject\">\n  <input type=\"email\" placeholder=\"email\">\n  <textarea placeholder=\"message\" name=\"\" id=\"\" cols=\"30\" rows=\"10\"></textarea> -->\n  <button (click)=\"sendEmail()\">Send Email</button>\n</form>"


//////////////////
// WEBPACK FOOTER
// ./src/app/send-email/send-email.component.html
// module id = ./src/app/send-email/send-email.component.html
// module chunks = main